<script>
function passwordMeetsPolicy(pw) {
  if (!pw || pw.length < 8) {
    return "รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร";
  }
  if (!/[0-9]/.test(pw)) {
    return "รหัสผ่านต้องมีตัวเลขอย่างน้อย 1 ตัว";
  }
  if (!/[A-Z]/.test(pw)) {
    return "รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษพิมพ์ใหญ่";
  }
  if (!/[a-z]/.test(pw)) {
    return "รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษพิมพ์เล็ก";
  }
  if (!/[^A-Za-z0-9]/.test(pw)) {
    return "รหัสผ่านต้องมีอักขระพิเศษอย่างน้อย 1 ตัว";
  }
  return "";
}

function parseJsonResponse(res) {
  return res.text().then(function (text) {
    var data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      data = { success: false, message: text || "API response ไม่ถูกต้อง" };
    }
    if (!res.ok) {
      throw new Error(data.message || "Request failed");
    }
    return data;
  });
}

export default {
  name: "ChangePassword",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      saving: false,
      alert: { type: "", message: "" },
    };
  },
  computed: {
    saveUrl: function () {
      return String((this.config && this.config.saveUrl) || "actions/account/change-password.php");
    },
    feedback: function () {
      var err = passwordMeetsPolicy(this.newPassword);
      if (!this.newPassword) {
        return { text: "", tone: "" };
      }
      if (err) {
        return { text: err, tone: "danger" };
      }
      if (this.confirmPassword && this.confirmPassword !== this.newPassword) {
        return { text: "รหัสผ่านใหม่กับช่องยืนยันไม่ตรงกัน", tone: "danger" };
      }
      if (this.confirmPassword && this.confirmPassword === this.newPassword) {
        return { text: "รหัสผ่านผ่านเงื่อนไขและตรงกับช่องยืนยันแล้ว", tone: "success" };
      }
      return { text: "รหัสผ่านผ่านเงื่อนไขแล้ว กรุณายืนยันรหัสผ่าน", tone: "muted" };
    },
  },
  methods: {
    submit: function () {
      var self = this;
      var err = passwordMeetsPolicy(this.newPassword);
      if (!this.currentPassword || !this.newPassword || !this.confirmPassword) {
        this.alert = { type: "danger", message: "กรุณากรอกให้ครบทุกช่อง" };
        return;
      }
      if (err) {
        this.alert = { type: "danger", message: err };
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.alert = { type: "danger", message: "รหัสผ่านใหม่กับช่องยืนยันไม่ตรงกัน" };
        return;
      }
      this.saving = true;
      this.alert = { type: "", message: "" };
      var body = new FormData();
      body.append("current_password", this.currentPassword);
      body.append("new_password", this.newPassword);
      body.append("new_password_confirm", this.confirmPassword);
      fetch(this.saveUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "เปลี่ยนรหัสผ่านไม่สำเร็จ");
          }
          self.currentPassword = "";
          self.newPassword = "";
          self.confirmPassword = "";
          self.alert = { type: "success", message: data.message || "เปลี่ยนรหัสผ่านสำเร็จ" };
        })
        .catch(function (e) {
          self.alert = { type: "danger", message: e.message || "เกิดข้อผิดพลาด" };
        })
        .finally(function () {
          self.saving = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">เปลี่ยนรหัสผ่าน</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">บัญชี</a></li>
              <li class="breadcrumb-item active">เปลี่ยนรหัสผ่าน</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="alert.message" class="alert alert-dismissible fade show" :class="alert.type === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
      {{ alert.message }}
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = ''"></button>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title mb-0">ตั้งรหัสผ่านใหม่</h4>
          </div>
          <div class="card-body">
            <form autocomplete="off" @submit.prevent="submit">
              <div class="mb-3">
                <label class="form-label" for="mct-current-password">รหัสผ่านปัจจุบัน</label>
                <input id="mct-current-password" v-model="currentPassword" type="password" class="form-control" autocomplete="current-password" required>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-new-password">รหัสผ่านใหม่</label>
                <input id="mct-new-password" v-model="newPassword" type="password" class="form-control" autocomplete="new-password" required>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-confirm-password">ยืนยันรหัสผ่านใหม่</label>
                <input id="mct-confirm-password" v-model="confirmPassword" type="password" class="form-control" autocomplete="new-password" required>
                <p v-if="feedback.text" class="form-text mb-0 mt-2" :class="'text-' + feedback.tone">{{ feedback.text }}</p>
                <p class="form-text mb-0 mt-2">ความยาวอย่างน้อย 8 ตัวอักษร ต้องมีตัวเลข ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และอักขระพิเศษ</p>
              </div>
              <button type="submit" class="btn btn-success" :disabled="saving">{{ saving ? "กำลังบันทึก..." : "บันทึกรหัสผ่านใหม่" }}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
